import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';



@Pipe({
  name: 'currency'
})

export class CurrencyProxyPipe implements PipeTransform {

  
  currencyPipe = new CurrencyPipe('en')
//{8}.{5}-{5}
  transform(value,code = 'IN',display = '',digites = '',local ='en') {
    if(localStorage.currency!==undefined){
      if(localStorage.currency==='OMR'){
        code="OMR"
      }
    }


     return this.currencyPipe.transform(value,code,display,digites,local)
  }

}
